interface Part {
  id: number
  name: string
}

function isPart(object: any) {
  return 'id' in object && 'name' in object
}

interface Unit extends Part {
  class: string
  attackType: string
  weaponType: string
}

function isUnit(object: any) {
  return isPart(object) && 'class' in object && 'attackType' in object && 'weaponType' in object
}

interface Frame {
  lArmUnit: undefined | null | Part
  rArmUnit: undefined | null | Part
  lBackUnit: undefined | null | Part
  rBackUnit: undefined | null | Part
  head: undefined | null | Part
  core: undefined | null | Part
  arms: undefined | null | Part
  legs: undefined | null | Part
  booster: undefined | null | Part
  fcs: undefined | null | Part
  generator: undefined | null | Part
  expansion: undefined | null | Part
}

interface ACData {
  id: undefined | number
  name: undefined | string
  user?: undefined | User
  platform: undefined | null | number
  shareKey: undefined | null | string
  frame: Frame
  lastUpdate?: undefined | string
}

interface User {
  username: string
  id: number
}

export type { Part, Unit, Frame, ACData, User};
export { isPart, isUnit }